<template>
  <Appendix
    title="Yêu cầu HĐ Ngân lượng"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <div>Mã HĐ: {{ item?.appendixNganluongConvert?.nganluongContractCode }}</div>
      <div>Hình thức ký: {{ getSignFormText(item) }}</div>
      <div>Tình trạng hoàn tất ký: {{ getSignStatusText(item) }}</div>
      <div v-if="item.appendixNganluongConvert">
        Lý do: {{ item.appendixNganluongConvert.reason || '' }}
      </div>
      <div>Phương thức ký: {{ item?.isRemote ? 'Ký từ xa' : 'Ký trực tiếp' }}</div>
    </template>
    <template #file="item">
      <div v-if="item?.urlPDF || item?.selfieOfMerchantByAppendix?.length > 0" class="form-detail">
        <UploadMultiple
          v-if="item.urlPDF"
          :lsData="[{ ...item, isOpenTab: item.urlPDF.includes('middleware-pdf') }]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File hợp đồng Ngân lượng`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
        <UploadMultiple
          v-if="item?.selfieOfMerchantByAppendix?.length > 0"
          :lsData="item?.selfieOfMerchantByAppendix"
          :canUpload="false"
          title="Ảnh selfie với MC"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
  </Appendix>
</template>

<script>
  import Appendix from './Appendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'

  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, UploadMultiple },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Mã yêu cầu', class: 'text-left' },
          { key: 'time', label: 'Thời gian', class: 'text-left', thStyle: 'min-width: 210px' },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center action' },
        ],
      }
    },
    methods: {
      getSignFormText(item) {
        const signForm = item?.appendixNganluongConvert?.signForm
        if (signForm === 'E_CONTRACT') return 'Ký điện tử'
        if (signForm === 'PAPER_CONTRACT') return 'Ký giấy'
        return signForm || ''
      },
      getSignStatusText(item) {
        const signStatus = item?.appendixNganluongConvert?.signOption || item?.signOption
        if (signStatus === 'MERCHANT_SIGNED') return 'MC đã ký'
        if (signStatus === 'MERCHANT_AND_COMPANY_SIGNED') return 'MC và công ty đã ký'
        return signStatus || ''
      },
    },
  }
</script>

<style scoped>
  ::v-deep .action {
    padding: 15px 0px !important;
  }
</style>
